import React from 'react';
import useToaster from '@app/component/overlays/toaster/ToasterHook';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import ProfileService from '@app/model/profile/service/ProfileService';
import useAppForm from '@app/site/_form';
import { z } from 'zod';

const ResetPasswordRequestPage = React.memo(() => {
	const toaster = useToaster();


	const ResetPasswordRequestFormValidation = z.object({
		email: z.string().email('Email is required'),
	});

	const form = useAppForm({
		defaultValues: {
			email: '',
		},
		validators: {
			onChange: ResetPasswordRequestFormValidation,
		},
		onSubmit: ({ value }) => onSubmit(value),
	});

	const onSubmit = (data: any) => {
		ProfileService.resetPasswordRequest(data.email)
			.then(() => toaster.success('Forgot Password', 'Your request has been submitted successfully!'))
			.catch(() => toaster.success('Forgot Password', 'Your request has been submitted successfully!'))
			.finally(() => form.reset({ email: '' }));
	};

	return <div className="min-h-full bg-white">
		<div className="flex lg:h-dvh min-w-max content-center justify-center flex-1">
			<div className="flex flex-1 flex-col justify-center px-6 py-12">
				<div className="mx-auto w-full max-w-sm lg:w-96">
					<div>
						<img
							className="h-10 w-auto"
							src="/assets/img/brand/logo-icon.png"
							alt="RoomPulse"
						/>
						<h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">
							Forgot Password
						</h2>
						<p className="mt-2 text-sm leading-6 text-gray-500">
							Already registered?{' '}
							<Link to="/sign-in" className="font-semibold text-blue-600 hover:text-blue-500"
										title="Click to sign in to your account">Go back to sign in</Link>
						</p>
					</div>

					<div className="mt-10">
						<div>
							<form.AppForm>
								<form className="space-y-6" onSubmit={
									(e) => {
										e.preventDefault();
										e.stopPropagation();
									}
								}>
									<div className="rounded-md bg-yellow-50 p-4">
										<div className="flex">
											<div className="flex-shrink-0">
												<ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" />
											</div>
											<div className="ml-3">
												<h3 className="text-sm font-medium text-yellow-800">We help you reset your
													password</h3>
												<div className="mt-2 text-sm text-yellow-700">
													<p>Please, enter your username and we'll send you an email with a link
														to reset your password!</p>
												</div>
											</div>
										</div>
									</div>
									<div>
										<form.AppField name="email"
										children={(field) => <field.TextField label="Email address" placeholder="Insert email"/>}/>
									</div>

									<div>
										<form.SubmitButton state="primary" extraClassName="w-full">
											Submit
										</form.SubmitButton>
									</div>
								</form>
							</form.AppForm>
						</div>
					</div>
				</div>
			</div>
			<div className="relative hidden flex-1 lg:block">
				<img
					className="absolute inset-0 h-full w-full object-cover"
					src="https://images.unsplash.com/photo-1625998464641-17bf5a53b9b7?q=80&w=2576&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
					alt=""
				/>
			</div>
		</div>
	</div>;
});

export default ResetPasswordRequestPage;